var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gz-auth-view-template',{attrs:{"bc":false,"contentClass":"gz-auth-view-template__content_inner"}},[_c('section',{staticClass:"gz-form gz-form_white",attrs:{"slot":"content"},slot:"content"},[_c('AddServiceEntityForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }